import ContactInput from '@components/contact-input/ContactInput';
import DateInput from '@components/date-picker/DatePicker';
import MultiSelectInput from '@components/multi-select';
import SelectInput from '@components/select/Select';
import Statement from '@components/statement/Statement';
import TableInput from '@components/table-input/TableInput';
import JpaTableInput from '@components/table-input/JpaTableInput';
import TextInput from '@components/text-input/TextInput';
import TextArea from '@components/textarea/TextArea';
import YesNoInput from '@components/yes-no-input/YesNoInput';
import { QUESTION_TYPE } from '@components/data-driven-form/ddf.validation';
import DynamicFileInput from './components/DynamicFileInput';
import DdfFileInput from '../data-driven-form/components/DdfFileInput';

export const InputMap = {
  [QUESTION_TYPE.basicContact]: ContactInput,
  [QUESTION_TYPE.contact]: ContactInput,
  [QUESTION_TYPE.date]: DateInput,
  [QUESTION_TYPE.file]: DynamicFileInput,
  [QUESTION_TYPE.longAnswer]: TextArea,
  [QUESTION_TYPE.multiselect]: MultiSelectInput,
  [QUESTION_TYPE.number]: TextInput,
  [QUESTION_TYPE.option]: SelectInput,
  [QUESTION_TYPE.shortAnswer]: TextInput,
  [QUESTION_TYPE.statement]: Statement,
  [QUESTION_TYPE.table]: TableInput,
  [QUESTION_TYPE.yesNo]: YesNoInput,
};

export const JpaInputMap = { ...InputMap, [QUESTION_TYPE.table]: JpaTableInput, [QUESTION_TYPE.file]: DdfFileInput };
